import { render, staticRenderFns } from "./editReceiverModal.vue?vue&type=template&id=25bce909&scoped=true"
import script from "./editReceiverModal.vue?vue&type=script&lang=js"
export * from "./editReceiverModal.vue?vue&type=script&lang=js"
import style0 from "./editReceiverModal.vue?vue&type=style&index=0&id=25bce909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bce909",
  null
  
)

export default component.exports